<script setup lang="ts">
// Vendor
import type { InvalidSubmissionContext } from "vee-validate";

// Types
import type { DefaultForm, TSchema } from "../types/baseform";

// Constants
import { FORM_CONTROL_ERROR_CLASS } from "../shared/constants";

const { initialErrors, initialValues, validationSchema } =
  defineProps<DefaultForm<TSchema>>();

const formWrapper = useTemplateRef("formWrapper");

const emit = defineEmits<{
  (event: "submit", values: TSchema): void;
  (event: "error", payload: InvalidSubmissionContext): void;
}>();

const { errors, handleSubmit, resetForm, setFieldValue, values } = useForm<
  Partial<TSchema>
>({
  initialErrors,
  initialValues,
  validationSchema,
});

const handleFormSubmit = handleSubmit(
  (values) => emit("submit", values),
  (payload) => {
    emit("error", payload);

    if (!import.meta.client) {
      return;
    }

    const firstErrorElement = formWrapper.value?.querySelector(
      `.${FORM_CONTROL_ERROR_CLASS}`,
    );

    if (firstErrorElement) {
      const { y } = firstErrorElement.getBoundingClientRect();

      window.scrollTo({
        top: y - 100,
        behavior: "smooth",
      });
    }
  },
);

defineExpose({
  errors,
  values,
  handleFormSubmit,
  resetForm,
  setFieldValue,
});
</script>

<template>
  <form
    ref="formWrapper"
    class="default-form"
    @submit.prevent="handleFormSubmit"
  >
    <slot />
  </form>
</template>
